/* Back Door recommendation carousels (snippets/bd-rec-carousel.liquid).
   Enhancement only - the track is a native horizontal scroller with snap,
   so swipe, trackpad and keyboard scrolling work without this file.
   Adds: previous / next buttons (shown >=750px, only when the track
   actually overflows), disabled at the start / end (no looping, no
   autoplay). Each click moves by the number of fully visible cards. A
   custom element, so it also wakes up when Dawn's recommendations loader
   injects the carousel after page load. */
if (!customElements.get('bd-rec-carousel')) {
  customElements.define(
    'bd-rec-carousel',
    class BdRecCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bd-rec-track]');
        this.arrows = this.querySelector('[data-bd-rec-arrows]');
        this.prev = this.querySelector('[data-bd-rec-prev]');
        this.next = this.querySelector('[data-bd-rec-next]');
        if (!this.track || !this.arrows || this.ready) return;
        this.ready = true;
        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.track);
        } else {
          window.addEventListener('resize', this.update);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.update);
      }

      step() {
        const item = this.track.querySelector('.bd-rec__item');
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const size = item.getBoundingClientRect().width + gap;
        return Math.max(1, Math.floor((this.track.clientWidth + gap) / size)) * size;
      }

      go(direction) {
        const button = direction < 0 ? this.prev : this.next;
        if (button.getAttribute('aria-disabled') === 'true') return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.arrows.hidden = max <= 1;
        // aria-disabled (not disabled): a button that reaches the end keeps focus.
        this.prev.setAttribute('aria-disabled', String(this.track.scrollLeft <= 1));
        this.next.setAttribute('aria-disabled', String(this.track.scrollLeft >= max - 1));
      }
    }
  );
}
